import React, { useEffect, useRef, useState } from 'react'
import Popup from 'reactjs-popup'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'
import FileNavigation from './FileNavigation'
import PendingMessageCount from '../FeedsTabContent/components/PendingMessageCount'

export default function FileNavigationPopup({
  isOpen,
  file,
  fileIndex,
  files,
  messageId,
  closeModal,
  deleteFile,
  showShareButton = true,
  loggedInUserId,
  enableDeleteFile,
  openedConversation = null,
  loadingFileDeletion,
  showPagination = true,
  isDecrypted = false,
  plain = false,
  renderFeedContent,
  feed,
  feedLevel,
  idNewsFeed
}) {
  const {
    common: { isNative, isMobile, isTablet, isDesktop },
    commonNewsfeed: {
      pendingMessageCount: { newsFeedId, count }
    }
  } = useSelector((state) => state)

  const isMobileDevice = isNative && isDesktop ? false : isNative || isMobile || isTablet
  const [fullScreen, setFullScreen] = useState(false)
  const [showPendingMessage, setShowPendingMessage] = useState(false)
  const feedContainerRef = useRef()

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    if ((newsFeedId === idNewsFeed || newsFeedId === 0) && count > 0) {
      setShowPendingMessage(true)
    } else {
      setShowPendingMessage(false)
    }
  }, [newsFeedId, count])

  const scrollToFeeds = () => {
    feedContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return file ? (
    <Popup
      lockScroll
      nested
      className='filepopup'
      contentStyle={{
        background: 'transparent',
        border: '0',
        width: '100vw',
        height: '100vh',
        padding: '0'
      }}
      overlayStyle={{
        background: isMobileDevice ? 'rgba(46, 45, 45, 0.8)' : 'rgba(46, 45, 45, 0.3)',
        backdropFilter: 'blur(4px)'
      }}
      open={isOpen}
      onClose={closeModal}>
      <div className={styles.container}>
        <FileNavigation
          isMobileDevice={isMobileDevice}
          file={file}
          fileIndex={fileIndex}
          files={files}
          showShareButton={showShareButton}
          loggedInUserId={loggedInUserId}
          enableDeleteFile={enableDeleteFile}
          openedConversation={openedConversation}
          loadingFileDeletion={loadingFileDeletion}
          showPagination={showPagination}
          isDecrypted={isDecrypted}
          plain={plain}
          deleteFile={deleteFile}
          closeModal={closeModal}
          isNative={isNative}
          fullScreen={feed ? fullScreen : true}
          setFullScreen={setFullScreen}
          feed={feed}
          scrollToFeeds={scrollToFeeds}
        />

        {renderFeedContent && (
          <div
            ref={feedContainerRef}
            className={`${styles.feedContainer} ${showPendingMessage && styles.withPendingMsg} ${
              fullScreen ? styles.hidden : styles.visible
            }`}>
            {showPendingMessage && <PendingMessageCount from='feed' count={count} className={styles.messageCount} />}
            {renderFeedContent(feed, fileIndex, false, true, feedLevel)}
          </div>
        )}
      </div>
    </Popup>
  ) : null
}
